import React, { createContext, useContext } from "react";
import { App, message } from "antd";

type ToastType = "success" | "error" | "warning";

interface ToastContextType {
  showToast: (type: ToastType, content: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const showToast = (type: ToastType, content: string) => {
    messageApi[type]({
      content,
      duration: 5,
    });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {contextHolder} {/* This is required to display the message */}
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
